import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { OfferService } from '../../services/offer.service';

import { OfferDetails } from '../../models/models';

@Injectable()
export class OfferResolve implements Resolve<any> {
  constructor(private offerService: OfferService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<OfferDetails> {
    return this.offerService.get(route.params.offerId);
  }
}
